import type { AppRouteRecordRaw } from '@/types/router'
import { ROUTE_NAMES } from '@/types/router'

// 通用路由配置 - 所有环境都需要的基础路由
export const commonRoutes: AppRouteRecordRaw[] = [
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: ROUTE_NAMES.NOT_FOUND,
    component: () => import('@/views/NotFound.vue'),
    meta: {
      titleKey: 'routeTitle.notFound',
      keepAlive: false,
    },
  },
] 